import { FC } from 'react';

import { IcDeleteIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import { useCancelVoiceButtonPresenter } from './CancelVoiceButton.presenter';

export const CancelVoiceButton: FC = () => {
  const presenter = useCancelVoiceButtonPresenter();

  return (
    <FAB
      size={'30'}
      onClick={presenter.onClick}
      Icon={IcDeleteIcon}
      theme={'8'}
    />
  );
};
